module.exports = __webpack_public_path__ + "static/media/AER.1d3037b5.png";